import { isGGI, isGFD } from "../actions/root_url";

export const getKeysMap = (key, keysMapObj) => keysMapObj[key] || key;
export const getSortVal = (key, desc) => {
  if (desc) {
    key = `-${key}`
  }
  return key
}
/**
 * Moves a column to the specified position in the table
 * @param {Array<Object>} columns
 * @param {Object<string: any>} condition
 * @param {Number} position
 * @return {Array<Object>} columns
 */
export const moveColumnToPosition = (columns, condition, position = -1) => {
  const [[key, value]] = Object.entries(condition);
  const index = columns.findIndex(column => column[key] === value);
  if (index !== -1) {
    const [column] = columns.splice(index, 1)
    if (position === -1) {
      columns.push(column);
    } else {
      columns.splice(position, 0, column);
    }
  }
  return columns;
}
const ggiAllCompaniesWhiteList = ['/purchaseOrder', '/salesOrders', '/salesInvoice', '/salesPerformanceReport', '/inventoriesnew','/customerStatementMain', '/customerStatementMain/', ...isGFD && ['/actionLog', '/actionLog/']];
export const isAllCompaniesWhiteList = (path) => {
  if(!path || path == null || path == NaN) {
    return false;
  }
  let isInside = false;
  if(isGGI || isGFD) {
    ggiAllCompaniesWhiteList.map(item => {
      if(path.endsWith(item)) {
        isInside = true;
      }
    })
  }
  return isInside;
}

export const isProductPage = (path) => { // is product file
  if(!path || path == null || path == NaN) {
    return false;
  }
  if(path.indexOf('/products/') != -1 && !path.endsWith('/products/categories') && !path.endsWith('/products/groups')) {
    return true;
  }
  return false;
}


function splitStringByLength(str, len) {
  if (str.length <= len) return [str];
  else return [str.substring(0, len)].concat(splitStringByLength(str.substring(len), len));
}
export const wrapLongWord = (text, maxWidth) => {
  let splitArray = splitStringByLength(text, maxWidth);
  if(splitArray.length == 1) {
    return splitArray[0];
  }
  let tx = '';
  splitArray.map((item, index) => {
    if(index == splitArray.length-1) {
      tx += item;
    } else {
      tx += item + '\n';
    }
  });
  return tx;
}

/**
 * compress image
 * @param file
 * @param maxWidth
 * @param maxHeight
 * @param quality
 * @return {Promise<unknown>}
 */
export function compressImage(file, maxWidth, maxHeight, quality) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader(); // 使用 FileReader 读取文件
    reader.readAsDataURL(file);      // 以 DataURL 格式读取&#8203;:contentReference[oaicite:9]{index=9}
    reader.onload = event => {
      const img = new Image();       // 创建 Image 对象&#8203;:contentReference[oaicite:10]{index=10}
      img.src = event.target.result; // 设置 src 为 DataURL&#8203;:contentReference[oaicite:11]{index=11}
      img.onload = () => {
        let { width, height } = img;
        // 计算缩放比例，保持纵横比
        if (width > maxWidth || height > maxHeight) {
          const ratio = Math.min(maxWidth / width, maxHeight / height);
          width = width * ratio;
          height = height * ratio;   // 保持等比缩放&#8203;:contentReference[oaicite:12]{index=12}
        }
        const canvas = document.createElement('canvas');
        canvas.width = width;        // 设置 Canvas 宽度&#8203;:contentReference[oaicite:13]{index=13}
        canvas.height = height;      // 设置 Canvas 高度&#8203;:contentReference[oaicite:14]{index=14}
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, width, height); // 绘制图像&#8203;:contentReference[oaicite:15]{index=15}
        // 导出结果 Blob，jpeg 格式和质量参数
        canvas.toBlob(blob => {
          if (blob) {
            resolve(blob);          // 返回压缩后的 Blob&#8203;:contentReference[oaicite:16]{index=16}
          } else {
            reject(new Error('压缩失败'));
          }
        }, 'image/jpeg', quality);  // MIME 类型和质量参数&#8203;:contentReference[oaicite:17]{index=17}
      };
      img.onerror = err => reject(err);
    };
    reader.onerror = error => reject(error);
  });
}



// WEBPACK FOOTER //
// ./master/jsx/utils/index.js